const baseUrl = `/vie/csp/mxuux/api/v1`;
const hsBaseUrl = '/vie/csp/healthshare';

export const environment = {
  production: true,
  releasedate:`11/01/2024`,
  releaseEnv:'prod',
  supportLink:'./contact/Contact.html',
  releasenotelist: '/vie/csp/mxuux/ui/assets/data/releasenotes/releasenotes-list.json',
  notifyUrlOrigin: 'https://mx-notify-prod.manifestmedex.org',
  
  aws: {
    region: 'us-west-2',
    identityPoolId: 'us-west-2:f9c12ffb-4cb6-410a-9704-047c74988439'
  },

  api: {
    baseUrl,
    initiateAuth: `${baseUrl}/auth/initiateAuth`,
    directAuth: `${baseUrl}/auth/directAuth`,
    respondToAuthChallenge: `${baseUrl}/auth/respondToAuthChallenge`,
    confirmDevice: `${baseUrl}/auth/confirmDevice`,
    rememberDevice: `${baseUrl}/auth/rememberDevice`,
    organizationList: `${baseUrl}/organization/list`,
    forgotPassword: `${baseUrl}/user/forgotPassword`,
    confirmForgotPassword: `${baseUrl}/user/confirmForgotPassword`,
    recoverUsername: `${baseUrl}/user/recoverUsername`,
    describeUserPool: `${baseUrl}/ui/describeUserPool`,
    getNewsFeed: `${baseUrl}/ui/getNewsFeed`,
    changePassword: `${baseUrl}/ui/changePassword`,
    npsExpiration: `${baseUrl}/ui/npsExpiration`,
    auditActivity: `${baseUrl}/ui/auditActivity`,
    setMfaPhone: `${baseUrl}/ui/setMfaPhone`,
    getBanner: `${baseUrl}/ui/getBanner`,

    adminListUsers: `${baseUrl}/ui/admin/listUsers`,
    adminListOrganizations: `${baseUrl}/ui/admin/listOrganizations`,
    adminListFacilities: `${baseUrl}/ui/admin/listFacilities`,
    adminGetUserDetails: `${baseUrl}/ui/admin/getUserDetails`,
    adminUpdateUserDetails: `${baseUrl}/ui/admin/updateUserDetails`,
    adminGetOrganizationDetails: `${baseUrl}/ui/admin/getOrganizationDetails`,
    adminUserAction: `${baseUrl}/ui/admin/userAction`,
    adminBulkLoadUsers: `${baseUrl}/ui/admin/bulkLoadUsers`,
    searchUser: `${baseUrl}/ui/admin/searchUser`,
    
    overlayList: `${baseUrl}/overlays/listRecords`,
    overlayIgnore: `${baseUrl}/overlays/ignoreRecords`,
    overlayAccept: `${baseUrl}/overlays/acceptRecords`,

    inboundPatientList: `${baseUrl}/inboundalert/listAlerts`,
    inboundPatientAcknowledgeAlert: `${baseUrl}/inboundalert/ackAlert`,

    setCVPatientContext: `${baseUrl}/ui/setCVPatientContext`,
  },

  assets: {
    mxLogo: `assets/images/MX-logo.png`,
    mxAccessPdf: `assets/data/MX-Access.pdf`,
    mxAccessAdminPdf: `assets/data/MX-Access-Admin.pdf`
  },

  settings: {
    session_timer: {
      timeout: 15 * 60 * 1000,
      interval: 10 * 1000,
      modal: { timeout: 60 * 1000 }
    },
    token_timer: {
      min_trigger: 5 * 60 * 1000,
      max_trigger: 8 * 60 * 1000,
      interval: 60 * 1000
    },
    forms: {
      close_timeout: 15 * 1000 // how long before close timer activates
    },
    toaster: {
      timeout: 5000 // 5 sec
    }
  },

  applications: {
    login: {
      name: 'Login',
      // TODO - set to UUX left side iframe url
      url:
        'https://docs.intersystems.com/latest/csp/docbook/DocBook.UI.Page.cls'
    },

    home: {
      name: 'Home',
      icon: 'fa-home',
      getUrl: () => {
        return {
          url: '',
          body: ''
        };
      },
      topLevelRedirect: false,
      noTimestamp: true,
      allowReload: true
    },

    admin: {
      name: 'Admin',
      icon: 'fa-cog',
      topLevelRedirect: false,
      noTimestamp: true,
      allowReload: true,
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;

        return {
          url:
            `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Admin.cls` +
            `?IRISUserName=${username}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      }
    },
    overlay: {
      name: 'Overlays',
      icon: 'fa-users',
      topLevelRedirect: false,
      noTimestamp: true,
      allowReload: true,
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;

        return {
          url:
            `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.OverlayAdmin.cls` +
            `?IRISUserName=${username}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      }
    },

    inboundPatient: {
      name: 'Inbound Patient',
      icon: 'fa-exclamation-triangle',
      topLevelRedirect: false,
      noTimestamp: true,
      allowReload: true,
      refreshTimer: 2 * 60 * 1000,
      auth: {
        username: 'alertvieweruser',
        password: 'sys'
      },
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;
        return {
          url:
            `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.InboundPatient.cls` +
            `?IRISUserName=${username}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      }
    },

    myAccount: {
      name: 'My Account',
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;

        return {
          url:
            `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.MyAccount.cls` +
            `?IRISUserName=${username}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      }
    },

    access: {
      name: 'Access',
      // icon: 'fa-id-card',
      image: 'MX-Access',
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;

        return {
          url:
            `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Access.cls` +
            `?IRISUserName=${username}&uuxSessionId=${uuxSessionId}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      },
      ignoredRoles: ['app-access-mxadmin', 'app-access-participantadmin'],
      getLogoutRequest: sessionStorage => {
        const uuxSessionId = sessionStorage.getUUXSessionId();
        return {
          get: {
            url: `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Logout.cls?uuxSessionId=${uuxSessionId}`,
            body: { uuxSessionId, patient: [] }
          }
        };
      },
      topLevelRedirect: false
    },
    report: {
      name: 'Audit Report',
      // icon: 'fa-id-card',
      image: 'MX-Report',
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;
        return {
          url:
            `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Report.cls`+
            `?IRISUserName=${username}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      },
      getLogoutRequest: sessionStorage => {
        const uuxSessionId = sessionStorage.getUUXSessionId();
        return {
          get: {
            url: `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Logout.cls?uuxSessionId=${uuxSessionId}`,
            body: { uuxSessionId, patient: [] }
          }
        };
      }
    },
    notify: {
      name: 'Notify',
      allowReload: true,
      // icon: 'fa-exclamation-triangle',
      image: 'MX-Notify',
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;
        return {
          url:
          `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.NOTIFY.cls`+
          `?IRISUserName=${username}&Env=Prod`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      },
      getLogoutRequest: sessionStorage => {
        const uuxSessionId = sessionStorage.getUUXSessionId();
        return {
          get: {
            url: `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Logout.cls?uuxSessionId=${uuxSessionId}`,
            body: { uuxSessionId, patient: [] }
          }
        };
      }
    }
    /* cmc: {
      name: 'CMC',
      allowReload: true,
      // icon: 'fa-exclamation-triangle',
      image: 'MX-CMC',
      getUrl: (sessionService, sessionStorageService) => {
        const user = sessionService.getUser(),
          token = sessionStorageService.getIdToken().encodedToken,
          uuxSessionId = sessionStorageService.getUUXSessionId(),
          username = user.username,
          userPoolId = user.organization.UserPoolId,
          org = user.organization.OrganizationId,
          region = environment.aws.region;
        return {
          url:
          `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.CMC.cls`+
          `?IRISUserName=${username}`,
          body: {
            token,
            userPoolId,
            region,
            org,
            uuxSessionId
          }
        };
      },
      getLogoutRequest: sessionStorage => {
        const uuxSessionId = sessionStorage.getUUXSessionId();
        return {
          get: {
            url: `/vie/csp/healthshare/mxuux/sso/MX.UUX.SSO.Logout.cls?uuxSessionId=${uuxSessionId}`,
            body: { uuxSessionId, patient: [] }
          }
        };
      }
    } */
  }
};
